import '@operato/property-editor/ox-property-editor-3axis.js'
import '@operato/property-editor/ox-property-editor-3dish.js'
import '@operato/property-editor/ox-property-editor-legend.js'
import '@operato/property-editor/ox-property-editor-description.js'
import '@operato/property-editor/ox-property-editor-number.js'
import '@operato/property-editor/ox-property-editor-unit-number.js'
import '@operato/property-editor/ox-property-editor-password.js'
import '@operato/property-editor/ox-property-editor-action.js'
import '@operato/property-editor/ox-property-editor-angle.js'
import '@operato/property-editor/ox-property-editor-string.js'
import '@operato/property-editor/ox-property-editor-data.js'
import '@operato/property-editor/ox-property-editor-date.js'
import '@operato/property-editor/ox-property-editor-month.js'
import '@operato/property-editor/ox-property-editor-time.js'
import '@operato/property-editor/ox-property-editor-datetime.js'
import '@operato/property-editor/ox-property-editor-checkbox.js'
import '@operato/property-editor/ox-property-editor-options.js'
import '@operato/property-editor/ox-property-editor-select.js'
import '@operato/property-editor/ox-property-editor-scene-component-id.js'
import '@operato/property-editor/ox-property-editor-color.js'
import '@operato/property-editor/ox-property-editor-multiple-colors.js'
import '@operato/property-editor/ox-property-editor-solid-colorstops.js'
import '@operato/property-editor/ox-property-editor-gradient-colorstops.js'
import '@operato/property-editor/ox-property-editor-textarea.js'
import '@operato/property-editor/ox-property-editor-table.js'
import '@operato/property-editor/ox-property-editor-key-values.js'
import '@operato/property-editor/ox-property-editor-partition-keys.js'
import '@operato/property-editor/ox-property-editor-value-map.js'
import '@operato/property-editor/ox-property-editor-value-ranges.js'
import '@operato/property-editor/ox-property-editor-hashtags.js'
import '@operato/property-editor/ox-property-editor-image.js'
import '@operato/property-editor/ox-property-editor-file.js'
import '@operato/attachment/ox-property-editor-attachment-selector.js'
import '@operato/attachment/ox-property-editor-image-selector.js'
import '@operato/font/ox-property-editor-font-selector.js'

import { OxPropertyEditor } from '@operato/property-editor'

OxPropertyEditor.register({
  legend: 'ox-property-editor-legend',
  description: 'ox-property-editor-description',
  number: 'ox-property-editor-number',
  'unit-number': 'ox-property-editor-unit-number',
  slider: 'ox-property-editor-range',
  password: 'ox-property-editor-password',
  action: 'ox-property-editor-action',
  angle: 'ox-property-editor-angle',
  string: 'ox-property-editor-string',
  textarea: 'ox-property-editor-textarea',
  javascript: 'ox-property-editor-textarea',
  script: 'ox-property-editor-textarea',
  checkbox: 'ox-property-editor-checkbox',
  boolean: 'ox-property-editor-checkbox',
  select: 'ox-property-editor-select',
  date: 'ox-property-editor-date',
  month: 'ox-property-editor-month',
  datetime: 'ox-property-editor-datetime',
  time: 'ox-property-editor-time',
  options: 'ox-property-editor-options',
  data: 'ox-property-editor-data',
  file: 'ox-property-editor-file',
  image: 'ox-property-editor-image',
  'range-input': 'ox-property-editor-range',
  'attachment-selector': 'ox-property-editor-attachment-selector',
  'gltf-selector': 'ox-property-editor-attachment-selector',
  'image-selector': 'ox-property-editor-image-selector',
  color: 'ox-property-editor-color',
  'solid-color-stops': 'ox-property-editor-solid-colorstops',
  'gradient-color-stops': 'ox-property-editor-gradient-colorstops',
  'multiple-color': 'ox-property-editor-multiple-colors',
  map: 'ox-property-editor-value-map',
  range: 'ox-property-editor-value-ranges',
  'editor-table': 'ox-property-editor-table',
  'id-input': 'ox-property-editor-scene-component-id',
  'font-selector': 'ox-property-editor-font-selector',
  'partition-keys': 'ox-property-editor-partion-keys',
  'key-values': 'ox-property-editor-key-values',
  hashtags: 'ox-property-editor-hashtags'
})
